



































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

import Schedules from "@/components/headers/schedules";

import Header from "@/types/app/header";
import Schedule from "@/types/app/schedules";
import ScheduleActions from "@/types/app/scheduleActionsPayload";

import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import Endpoint from "@/utils/endpoint";
import { getProducts } from "@/utils/getProducts";
import router from "@/router";

import ScheduleModal from "@/components/common/ScheduleModal.vue";
import ScheduleFeedback from "@/components/common/ScheduleFedbackModal.vue";
import applyCondition from "@/utils/applyCondition";
import RefreshStore from "@/services/refreshStore";
const namespace = "customer";

const NEXT_SCHEDULES = 1;
const PREVIOUS_SCHEDULES = 2;

interface Success {
  success: boolean;
}

@Component({
  methods: {
    formatMoney,
    formatDate,
    truncate,
  },
  components: {
    ScheduleModal: ScheduleModal,
    ScheduleFeedback: ScheduleFeedback,
  },
})
export default class SchedulesList extends Vue {
  @Action("setModalScheduleState", { namespace })
  setModalScheduleState!: any;

  @Action("setScheduleState", { namespace })
  setScheduleState!: any;

  @Action("setScheduleFeedbackModalState", { namespace })
  setScheduleFeedbackModalState!: any;

  private endpoint = new Endpoint();

  schedules: Schedule[] = [];

  loadingSchedules = false;
  loadingApprove = false;
  loadingReject = false;
  headers: Header[] = Schedules.header;
  schedulesShearch = "";

  firstNameFilter = "";
  emailFilter = "";
  startingTimeFilter = "";

  filterSchedules = NEXT_SCHEDULES;
  feedbackFlag = "";

  public changeScheduleFilter(filter: number) {
    this.filterSchedules = filter;
  }

  get isScheduleNotExpired() {
    return this.filterSchedules === NEXT_SCHEDULES ? true : false;
  }

  @Watch("filterSchedules")
  async getSchedules() {
    this.loadingSchedules = true;
    try {
      const schedules = await this.$http.get(this.endpoint.schedule, {
        params: { NoExpired: this.isScheduleNotExpired },
      });
      this.schedules = schedules.data !== null ? schedules.data : [];
    } catch (error) {
      console.error("handleProducts", error);
    }
    this.loadingSchedules = false;
  }

  get filteredSchedules() {
    const conditions: any[] = [];
    if (this.firstNameFilter) {
      conditions.push((item: Schedule) =>
        `${item.firstName} ${item.lastName}`
          .toLowerCase()
          .includes(this.firstNameFilter.toLowerCase())
      );
    }

    if (this.emailFilter) {
      conditions.push((item: Schedule) =>
        item.email.toLowerCase().includes(this.emailFilter.toLowerCase())
      );
    }

    if (this.startingTimeFilter) {
      conditions.push((item: Schedule) =>
        formatDate(item.startingTime)?.includes(this.startingTimeFilter.toLowerCase())
      );
    }

    return applyCondition<Schedule>(this.schedules, conditions);
  }

  showScheduleData(item: Schedule) {
    this.setScheduleState(item);
    this.setModalScheduleState(true);
  }

  public async approveSchedule(schedule: ScheduleActions) {
    this.loadingApprove = true;
    try {
      const response = (await this.$http.put(
        this.endpoint.scheduleAction +
          `/${schedule.userId}/${schedule.scheduleId}?isApproved=${schedule.isApproved}`
      )) as Success;
      this.feedbackFlag = "Approved";
      if (response.success) this.setScheduleFeedbackModalState(true);
    } catch (error) {
      console.error("An error was ");
    }
    this.loadingApprove = false;
    this.setScheduleFeedbackModalState(true);
  }

  public async rejectSchedule(schedule: ScheduleActions) {
    this.loadingReject = true;
    try {
      const response = (await this.$http.put(
        this.endpoint.scheduleAction +
          `/${schedule.userId}/${schedule.scheduleId}?isApproved=${schedule.isApproved}`
      )) as Success;
      this.feedbackFlag = "Rejected";
      if (response.success) this.setScheduleFeedbackModalState(true);
    } catch (error) {
      console.error("An error was ");
    }
    this.loadingReject = false;
  }

  async mounted() {
    await this.getSchedules();
  }
}
